/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/progress'
export default icon
